export default __webpack_public_path__ + "static/media/crypto.2664d46b.jpg";